import React from 'react';
import { getScoreLevel, MAX_SCORE } from '../data/services';

export const Gauge = ({ score }) => {
  const { color, label } = getScoreLevel(score);
  const percentage = Math.min((score / MAX_SCORE) * 100, 100);
  
  // SVG arc calculations for semi-circle
  const radius = 80;
  const strokeWidth = 12;
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = normalizedRadius * Math.PI; // Semi-circle
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div className="flex flex-col items-center" data-testid="score-gauge">
      <div className="relative">
        <svg
          width={radius * 2}
          height={radius + 20}
          className="transform"
        >
          {/* Background arc */}
          <path
            d={`M ${strokeWidth / 2} ${radius} A ${normalizedRadius} ${normalizedRadius} 0 0 1 ${radius * 2 - strokeWidth / 2} ${radius}`}
            fill="none"
            stroke="#E2E8F0"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
          {/* Foreground arc */}
          <path
            d={`M ${strokeWidth / 2} ${radius} A ${normalizedRadius} ${normalizedRadius} 0 0 1 ${radius * 2 - strokeWidth / 2} ${radius}`}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            className="gauge-animated"
            style={{
              transition: 'stroke-dashoffset 1.5s ease-out',
            }}
          />
        </svg>
        
        {/* Score display */}
        <div className="absolute inset-0 flex flex-col items-center justify-end pb-2">
          <span 
            className="text-4xl font-bold font-outfit"
            style={{ color }}
            data-testid="score-value"
          >
            {score}
          </span>
          <span className="text-sm text-slate-500">points</span>
        </div>
      </div>
      
      {/* Level badge */}
      <div 
        className="mt-4 px-4 py-2 rounded-full font-semibold text-sm"
        style={{ backgroundColor: `${color}20`, color }}
        data-testid="score-level"
      >
        {label}
      </div>
    </div>
  );
};

export default Gauge;
